import { z } from 'zod';

// ── Create client ──────────────────────────────────────────────────
export const createClientSchema = z.object({
  nombre: z
    .string()
    .min(3, 'El nombre debe tener al menos 3 caracteres')
    .max(200, 'Máximo 200 caracteres'),
  rucCi: z.preprocess(
    (v) => (typeof v === 'string' && v.trim() === '' ? null : v),
    z.string().max(20, 'Máximo 20 caracteres').optional().nullable(),
  ),
  telefono: z.string().max(20, 'Máximo 20 caracteres').optional().nullable(),
  email: z.preprocess(
    (v) => (typeof v === 'string' && v.trim() === '' ? null : v),
    z.string().email('Correo electrónico inválido').optional().nullable(),
  ),
  direccion: z.string().max(500, 'Máximo 500 caracteres').optional().nullable(),
});

export type CreateClientInput = z.infer<typeof createClientSchema>;

// ── Update client (partial) ────────────────────────────────────────
export const updateClientSchema = createClientSchema.partial();
export type UpdateClientInput = z.infer<typeof updateClientSchema>;

// ── List clients query ─────────────────────────────────────────────
export const listClientsSchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
});

export type ListClientsInput = z.infer<typeof listClientsSchema>;

// ── Client ID param ────────────────────────────────────────────────
export const clientParamsSchema = z.object({
  id: z.string().uuid('ID de cliente inválido'),
});

export type ClientParams = z.infer<typeof clientParamsSchema>;
